<template>
  <div class="news-container" id="page-news">
    <img class="news-title" src="https://staticweb.ewan.cn/resources/img/ddj-tw/news.png" alt="" />
    <div class="news-content">
      <div class="house">
        <div class="swiper-container news-swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/banner01.jpg" alt="" />
            </div>
            <div class="swiper-slide">
              <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/banner02.jpg" alt="" />
            </div>
            <div class="swiper-slide">
              <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/banner03.jpg" alt="" />
            </div>
            <div class="swiper-slide">
              <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/banner04.jpg" alt="" />
            </div>
            <div class="swiper-slide">
              <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/banner05.jpg" alt="" />
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>
        </div>
        <div class="news-list">
          <div class="news-item">
            <ul>
              <li
                @click="jumpLink('/detail', item)"
                v-for="(item, index) in newsData"
                :key="index"
              >
                <div class="circle"></div>
                <div class="title">{{ item.title }}</div>
                <div class="date-time">{{ item.time }}</div>
              </li>
            </ul>
          </div>
          <div class="news-more">
            <div class="more-text" @click="jumpLink('/list')">
              更多<span>↑</span>
            </div>
          </div>
        </div>
        <div class="cut-btn">
          <div
            class="cut-item"
            v-for="(item, index) in bottomItems"
            :class="{ active: item.value == active_item }"
            @click="changeItem(item.value)"
            :key="index"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="coins-top-left">
      <img class="news-title" src="https://staticweb.ewan.cn/resources/img/ddj-tw/coin.png" alt="" />
    </div>
    <div class="coins-buttom-left">
      <img class="news-title" src="https://staticweb.ewan.cn/resources/img/ddj-tw/coin.png" alt="" />
    </div> -->
  </div>
</template>
<script>
import jsonData from "@/assets/data.js";
export default {
  data() {
    return {
      bottomItems: [
        { label: "綜合", value: "all" },
        { label: "公告", value: "announcement" },
        { label: "活動", value: "activity" },
        { label: "新闻", value: "news" },
      ],
      active_item: "all",
    };
  },
  mounted() {
    this.$nextTick(() => {
      new this.$Swiper(".news-swiper-container", {
        loop: true,
        speed: 500,
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 允许点击小圆点跳转
        },
        //如果需要自动切换海报
        autoplay: {
          delay: 1000,
          disableOnInteraction: false, // 手动切换之后继续自动轮播
        },
      });
    });
  },

  computed: {
    newsData() {
      let data = [];
      let formatData = (type, datas = []) => {
        let type_data = [];
        datas.forEach((e) => {
          type_data.push({
            title: e.title,
            time: this.formatTime(e.time),
            id: e.id,
            type,
          });
        });
        return type_data;
      };
      if (this.active_item == "all") {
        let all = [];
        this.bottomItems.forEach((element) => {
          let item_data = jsonData[element.value] || [];
          item_data = formatData(element.value, item_data);
          all = all.concat(item_data);
        });
        data = all.sort((a,b)=> new Date(b.time) - new Date(a.time)).splice(0,5);
      } else {
        data = jsonData[this.active_item] || [];
        data = formatData(this.active_item, data);
      }
      return data;
    },
  },

  methods: {
    jumpLink(path, item) {
      if (path.includes("detail")) {
        let type = item.type,
          id = item.id;
        this.$router.push({ path, query: { type, id } });
      } else {
        this.$router.push(path);
      }
    },

    formatTime(time) {
      return time.replace(/-/g, ".");
    },

    changeItem(item) {
      this.active_item = item;
    },
  },
};
</script>
<style scoped lang="scss" src="./scss/news.scss"></style>